import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 pointer-events-none" }
const _hoisted_2 = { class: "flex flex-col items-end justify-start space-y-4 p-4" }

import { useNotificationStore } from '@/store/notifications';
import Notification from './Notification.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationContainer',
  setup(__props) {

const notificationStore = useNotificationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationStore).notifications, (notification) => {
        return (_openBlock(), _createBlock(Notification, {
          key: notification.id,
          notification: notification,
          onClose: ($event: any) => (_unref(notificationStore).removeNotification(notification.id))
        }, null, 8, ["notification", "onClose"]))
      }), 128))
    ])
  ]))
}
}

})